<template>
	<div
		class="tw-absolute tw-min-w-full tw-min-h-full tw-flex tw-items-center tw-justify-center tw-z-[9000] tw-bg-white tw-bg-opacity-50">
		<div class="tw-flex tw-flex-col tw-items-center tw-justify-center">
			<div
				class="tw-animate-spin tw-rounded-full tw-h-20 tw-w-20 tw-border-t-4 tw-border-b-4 tw-border-[#f35610] tw-mb-8">
			</div>
			<p class="tw-text-[#f35610] tw-font-BebasNeueProBold tw-text-3xl">Checking Authentication ...</p>
		</div>
	</div>
</template>

<script setup>
// Simple loading spinner for authentication checks
</script>

<style scoped>
.animate-spin {
	animation: spin 1s linear infinite;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}

	to {
		transform: rotate(360deg);
	}
}
</style>